<div [attr.data-qa]="qaTag" class="modal-dialog modal-dialog-fixed-width">
    <span [attr.data-qa]="qaTag + '-message'" [innerHTML]="(isChecking() ? 'ERROR.CONNECTION_LOST.RECONNECTING' : 'ERROR.CONNECTION_LOST.MESSAGE') | translate" class="modal-dialog-message"></span>
    @if (hasRetryFailed() && !isChecking()) {
        <span [attr.data-qa]="qaTag + '-retry-error'" class="connection-lost-dialog-retry-error">{{ 'ERROR.CONNECTION_LOST.RETRY_FAILED' | translate }}</span>
    }
    <div class="modal-dialog-action-text-buttons">
        <app-button (clicked)="checkConnection()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.RED"
                    [buttonText]="'ERROR.CONNECTION_LOST.BUTTON_RECONNECT' | translate"
                    [isDisabled]="isChecking()"
                    [qaTag]="qaTag + '-reconnect-button'"/>
        <app-button (clicked)="closeModal()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                    [buttonText]="'ERROR.CONNECTION_LOST.BUTTON_GO_TO_LOGIN' | translate"
                    [isDisabled]="isChecking()"
                    [qaTag]="qaTag + '-goto-login-button'"/>
    </div>
</div>
